import { IBasicCellProps } from "@src/components/fields/types";

export default function BasicCellName({ name }: IBasicCellProps) {
  return <>{name}</>;
}
